import { __spreadArray } from "tslib";
import { actionKey } from './constants';
function getState(state) {
    return (state[actionKey] || {
        fileUploads: [],
        fileUploadsWaiting: [],
    });
}
export var getUploads = function (state) {
    return getState(state).fileUploads;
};
export var getUploadsWaiting = function (state) {
    return getState(state).fileUploadsWaiting;
};
export var getAllUploads = function (state) {
    return __spreadArray(__spreadArray([], getUploads(state), true), getUploadsWaiting(state), true);
};
export var getUploadById = function (state, fileId) {
    return getAllUploads(state).find(function (fu) { return fu.fileId === fileId; });
};
export var getUploadsByTag = function (state, tag) {
    if (!tag) {
        return [];
    }
    return getAllUploads(state).filter(function (fu) { return fu.tag === tag; });
};
//# sourceMappingURL=selectors.js.map